import React from 'react';
import { Typography, Button, Card, Row, Col } from 'antd';
import { LoginOutlined, BookOutlined, TeamOutlined, SettingOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Home = ({ onNavigateToLogin }) => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <Title level={1} className="text-primary text-5xl font-bold mb-4">
            Welcome to TapLearnGo!
          </Title>
          <Paragraph className="text-xl text-gray-600 mb-8">
            Creating a culture of learning
          </Paragraph>
          
          <Button 
            type="default" 
            size="large"
            icon={<LoginOutlined />}
            onClick={onNavigateToLogin}
            className="bg-primary hover:bg-blue-700 border-primary hover:border-blue-700 h-12 px-8 text-base font-medium"
          >
            Go to Login Page
          </Button>
        </div>

        <Row gutter={[24, 24]} className="mt-16">
          <Col xs={24} sm={12} lg={6}>
            <Card
              hoverable
              className="text-center h-48 shadow-md hover:shadow-lg transition-shadow"
              bodyStyle={{ padding: '24px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            >
              <BookOutlined className="text-4xl text-primary mb-4" />
              <Title level={4} className="mb-2">Learning Modules</Title>
              <Paragraph className="text-gray-600 text-sm">
                Access interactive learning content and courses
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} lg={6}>
            <Card
              hoverable
              className="text-center h-48 shadow-md hover:shadow-lg transition-shadow"
              bodyStyle={{ padding: '24px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            >
              <TeamOutlined className="text-4xl text-primary mb-4" />
              <Title level={4} className="mb-2">Groups & Teams</Title>
              <Paragraph className="text-gray-600 text-sm">
                Collaborate with colleagues and manage learning groups
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} lg={6}>
            <Card
              hoverable
              className="text-center h-48 shadow-md hover:shadow-lg transition-shadow"
              bodyStyle={{ padding: '24px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            >
              <SettingOutlined className="text-4xl text-primary mb-4" />
              <Title level={4} className="mb-2">Administration</Title>
              <Paragraph className="text-gray-600 text-sm">
                Manage users, content, and system settings
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} lg={6}>
            <Card
              hoverable
              className="text-center h-48 shadow-md hover:shadow-lg transition-shadow"
              bodyStyle={{ padding: '24px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            >
              <LoginOutlined className="text-4xl text-primary mb-4" />
              <Title level={4} className="mb-2">Get Started</Title>
              <Paragraph className="text-gray-600 text-sm">
                Login to access your personalized learning dashboard
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Home;